import { claimApi } from 'store/baseApi';
import { Feedback } from './types';

const createFeedback = (params: Feedback) =>
  claimApi.post('claims/feedback', params);

export default {
  createFeedback,
};
